const QUOTES: readonly { text: string; author: string }[] = [
  {
    text: "Le secret du changement, c'est de concentrer toute votre énergie non pas à lutter contre le passé, mais à construire l'avenir.",
    author: "Socrate",
  },
  {
    text: "La seule limite à notre épanouissement de demain sera nos doutes d'aujourd'hui.",
    author: "Franklin Roosevelt",
  },
  {
    text: "Ce n'est pas parce que les choses sont difficiles que nous n'osons pas, c'est parce que nous n'osons pas qu'elles sont difficiles.",
    author: "Sénèque",
  },
  {
    text: "La vraie gloire consiste à faire ce qui mérite d'être fait et à espérer qu'on le saura.",
    author: "Gustave Flaubert",
  },
  {
    text: "Celui qui pense qu'il peut et celui qui pense qu'il ne peut pas ont tous les deux raison.",
    author: "Henry Ford",
  },
  {
    text: "Le seul vrai succès, c'est de faire de votre vie ce que vous avez toujours voulu en faire.",
    author: "Marc Levy",
  },
  {
    text: "Votre limite n'existe que dans votre esprit. Dépassez votre peur et vous dépasserez tout.",
    author: "Unknown",
  },
  {
    text: "Les obstacles sont les passerelles du progrès. C'est en les franchissant qu'on grandit.",
    author: "Ralph Waldo Emerson",
  },
  {
    text: "Ne renoncez jamais à vos rêves. Peut-être que les débuts seront difficiles, mais le meilleur commence toujours difficilement.",
    author: "Unknown",
  },
  {
    text: "La vie est 10% ce qui vous arrive et 90% comment vous réagissez à cela.",
    author: "Charles R. Swindoll",
  },
  {
    text: "Chaque nouveau jour est une chance de changer votre vie.",
    author: "Ralph Marston",
  },
  {
    text: "Le courage est la résistance à la peur, la maîtrise de la peur - et non l'absence de peur.",
    author: "Mark Twain",
  },
  {
    text: "Tout ce que tu peux concevoir et croire, tu peux le réaliser.",
    author: "Napoleon Hill",
  },
  {
    text: "La discipline est choisir ce que tu veux le plus plutôt que ce que tu veux maintenant.",
    author: "Abraham Lincoln",
  },
  {
    text: "Croyez en vous. Si vous n'y croyez pas, qui d'autre le fera?",
    author: "Unknown",
  },
  {
    text: "Chaque étape que vous franchissez vous rapproche de votre but. Ne vous découragez pas.",
    author: "Unknown",
  },
  {
    text: "Votre plus grand ennemi ne peut pas vous faire autant de mal que vos propres pensées.",
    author: "Buddha",
  },
  {
    text: "Quand on veut, on peut. La vraie question est: avez-vous envie?",
    author: "Paulo Coelho",
  },
  {
    text: "Chaque jour est un nouveau commencement. Profitez-en.",
    author: "Ralph Marston",
  },
  {
    text: "La réussite n'est pas définitive, l'échec n'est pas fatal. C'est le courage de continuer qui compte.",
    author: "Winston Churchill",
  },
];

import { useState } from "react";

export function QuoteOfTheDay() {
  const [quote] = useState(() => {
    const dayOfYear = Math.floor(Date.now() / 86400000) % QUOTES.length;
    return QUOTES[dayOfYear];
  });

  return (
    <div className="px-3 py-2 border-l-2 border-accent">
      <p className="text-xs italic text-ink-muted leading-snug">
        "{quote.text}"
        <span className="not-italic text-ink-faint ml-1">— {quote.author}</span>
      </p>
    </div>
  );
}
